/**
 * Normalizes a failed API request into copy that is honest about what happened.
 * It deliberately keeps server diagnostics bounded: user text, tokens and
 * provider payloads never become part of the rendered error.
 */
export function normalizeAthenaApiFailure(error, fallback = 'Não consegui concluir isso agora. Tente novamente em instantes.') {
  const status = Number(error?.response?.status) || 0;
  const payload = error?.response?.data && typeof error.response.data === 'object'
    ? error.response.data
    : {};
  const code = typeof payload.error_code === 'string'
    ? payload.error_code
    : (typeof payload.code === 'string' ? payload.code : '');
  const requestId = typeof payload.request_id === 'string' ? payload.request_id.slice(0, 120) : null;
  const remoteMessage = typeof payload.response === 'string'
    ? payload.response
    : (typeof payload.detail === 'string' ? payload.detail : '');
  const timeout = error?.code === 'ECONNABORTED'
    || /timeout|aborted/i.test(String(error?.message || ''));

  if (status === 401 || status === 403) {
    return {
      status,
      code: 'SESSION_EXPIRED',
      requestId,
      userMessage: 'Sua sessão foi atualizada ou expirou. Entre novamente para continuar.',
    };
  }
  if (timeout) {
    return {
      status,
      code: 'REQUEST_TIMEOUT',
      requestId,
      userMessage: 'A resposta demorou mais que o normal. Sua mensagem não foi repetida; tente enviar novamente.',
    };
  }
  const providerFallbacks = {
    LLM_PROVIDER_AUTH: 'A conexão segura da Athena com o serviço de respostas precisa ser renovada. Tente novamente em alguns instantes.',
    LLM_RATE_LIMITED: 'A Athena atingiu temporariamente o limite do serviço de respostas. Aguarde um instante e tente novamente.',
    LLM_MODEL_UNAVAILABLE: 'O serviço de respostas da Athena está temporariamente indisponível. Tente novamente em instantes.',
    LLM_UPSTREAM_UNAVAILABLE: 'O serviço de respostas da Athena está indisponível agora. Tente novamente em instantes.',
    LLM_REQUEST_REJECTED: 'Não foi possível concluir essa resposta agora. Tente novamente em instantes.',
  };
  return {
    status,
    code: code || (status >= 500 ? 'SERVICE_UNAVAILABLE' : 'REQUEST_FAILED'),
    requestId,
    userMessage: remoteMessage.trim().slice(0, 500) || providerFallbacks[code] || fallback,
  };
}

export function isAthenaSessionFailure(failure) {
  return failure?.status === 401 || failure?.status === 403 || failure?.code === 'SESSION_EXPIRED';
}
